import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=567dbfde&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=567dbfde&prod&scoped=true&lang=css"
import style1 from "./notifications.vue?vue&type=style&index=1&id=567dbfde&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567dbfde",
  null
  
)

export default component.exports